import { render, staticRenderFns } from "./ToolBarNew.vue?vue&type=template&id=541b9178&scoped=true"
import script from "./ToolBarNew.vue?vue&type=script&lang=js"
export * from "./ToolBarNew.vue?vue&type=script&lang=js"
import style0 from "./ToolBarNew.vue?vue&type=style&index=0&id=541b9178&prod&scoped=true&lang=css"
import style1 from "./ToolBarNew.vue?vue&type=style&index=1&id=541b9178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b9178",
  null
  
)

export default component.exports